import React, { useState } from 'react';
import { FaQuestionCircle } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { createPackage } from '../services/packages.service';
import Navbar from '../components/Navbar';
import BottomNav from '../components/BottomNav';

const DISTANCIAS = {
  'madrid-barcelona': 620, 'barcelona-madrid': 620,
  'madrid-valencia': 355, 'valencia-madrid': 355,
  'madrid-sevilla': 530, 'sevilla-madrid': 530,
  'madrid-malaga': 545, 'malaga-madrid': 545,
  'madrid-granada': 435, 'granada-madrid': 435,
  'madrid-zaragoza': 325, 'zaragoza-madrid': 325,
  'madrid-bilbao': 395, 'bilbao-madrid': 395,
  'madrid-salamanca': 215, 'salamanca-madrid': 215,
  'madrid-valladolid': 195, 'valladolid-madrid': 195,
  'madrid-toledo': 75, 'toledo-madrid': 75,
  'madrid-cuenca': 170, 'cuenca-madrid': 170,
  'madrid-albacete': 255, 'albacete-madrid': 255,
  'madrid-murcia': 400, 'murcia-madrid': 400,
  'madrid-alicante': 420, 'alicante-madrid': 420,
  'madrid-cordoba': 400, 'cordoba-madrid': 400,
  'madrid-cadiz': 650, 'cadiz-madrid': 650,
  'barcelona-valencia': 350, 'valencia-barcelona': 350,
  'barcelona-zaragoza': 300, 'zaragoza-barcelona': 300,
  'barcelona-tarragona': 100, 'tarragona-barcelona': 100,
  'barcelona-girona': 100, 'girona-barcelona': 100,
  'barcelona-lleida': 160, 'lleida-barcelona': 160,
  'barcelona-castellon': 270, 'castellon-barcelona': 270,
  'barcelona-alicante': 525, 'alicante-barcelona': 525,
  'barcelona-murcia': 590, 'murcia-barcelona': 590,
  'valencia-alicante': 165, 'alicante-valencia': 165,
  'valencia-murcia': 230, 'murcia-valencia': 230,
  'valencia-castellon': 75, 'castellon-valencia': 75,
  'valencia-albacete': 190, 'albacete-valencia': 190,
  'sevilla-malaga': 210, 'malaga-sevilla': 210,
  'sevilla-granada': 260, 'granada-sevilla': 260,
  'sevilla-cadiz': 125, 'cadiz-sevilla': 125,
  'sevilla-cordoba': 140, 'cordoba-sevilla': 140,
  'malaga-granada': 130, 'granada-malaga': 130,
  'granada-almeria': 170, 'almeria-granada': 170,
  'granada-motril': 65, 'motril-granada': 65,
  'motril-malaga': 100, 'malaga-motril': 100,
  'malaga-almeria': 200, 'almeria-malaga': 200,
  'malaga-cordoba': 160, 'cordoba-malaga': 160,
  'cordoba-granada': 200, 'granada-cordoba': 200,
  'cadiz-malaga': 235, 'malaga-cadiz': 235,
  'bilbao-san sebastian': 100, 'san sebastian-bilbao': 100,
  'bilbao-santander': 100, 'santander-bilbao': 100,
  'bilbao-vitoria': 65, 'vitoria-bilbao': 65,
  'vitoria-san sebastian': 100, 'san sebastian-vitoria': 100,
  'santander-oviedo': 190, 'oviedo-santander': 190,
  'oviedo-gijon': 30, 'gijon-oviedo': 30,
  'valladolid-leon': 140, 'leon-valladolid': 140,
  'valladolid-burgos': 130, 'burgos-valladolid': 130,
  'burgos-bilbao': 160, 'bilbao-burgos': 160,
  'salamanca-valladolid': 120, 'valladolid-salamanca': 120,
  'murcia-alicante': 80, 'alicante-murcia': 80,
  'murcia-almeria': 220, 'almeria-murcia': 220,
  'albacete-murcia': 150, 'murcia-albacete': 150,
};

const CIUDADES_COORDS = {
  madrid: [40.4168, -3.7038], barcelona: [41.3874, 2.1686],
  valencia: [39.4699, -0.3763], sevilla: [37.3891, -5.9845],
  malaga: [36.7213, -4.4214], granada: [37.1773, -3.5986],
  bilbao: [43.2630, -2.9350], zaragoza: [41.6561, -0.8773],
  alicante: [38.3452, -0.4810], murcia: [37.9922, -1.1307],
  cordoba: [37.8882, -4.7794], cadiz: [36.5271, -6.2886],
  almeria: [36.8340, -2.4637], motril: [36.7457, -3.5220],
  toledo: [39.8628, -4.0273], valladolid: [41.6523, -4.7245],
  salamanca: [40.9701, -5.6635], burgos: [42.3440, -3.6969],
  santander: [43.4623, -3.8099], oviedo: [43.3614, -5.8593],
  gijon: [43.5453, -5.6615], vitoria: [42.8467, -2.6726],
  'san sebastian': [43.3183, -1.9812], leon: [42.5987, -5.5671],
  albacete: [38.9943, -1.8585], castellon: [39.9864, -0.0513],
  tarragona: [41.1189, 1.2445], girona: [41.9794, 2.8214],
  lleida: [41.6176, 0.6200], pamplona: [42.8125, -1.6458],
  logrono: [42.4650, -2.4450], huesca: [42.1401, -0.4089],
  teruel: [40.3456, -1.1065], cuenca: [40.0704, -2.1374],
  guadalajara: [40.6330, -3.1670], caceres: [39.4753, -6.3724],
  badajoz: [38.8794, -6.9707], huelva: [37.2614, -6.9447],
  jaen: [37.7796, -3.7849], palencia: [42.0096, -4.5288],
  zamora: [41.5034, -5.7447], avila: [40.6566, -4.6814],
  segovia: [40.9429, -4.1088], soria: [41.7640, -2.4790],
  lugo: [43.0097, -7.5560], orense: [42.3362, -7.8639],
  pontevedra: [42.4334, -8.6474], vigo: [42.2314, -8.7124],
  coruña: [43.3623, -8.4115], santiago: [42.8782, -8.5448],
};

const haversineKm = (c1, c2) => {
  const R = 6371;
  const dLat = (c2[0] - c1[0]) * Math.PI / 180;
  const dLon = (c2[1] - c1[1]) * Math.PI / 180;
  const a = Math.sin(dLat/2) ** 2 +
    Math.cos(c1[0] * Math.PI / 180) *
    Math.cos(c2[0] * Math.PI / 180) *
    Math.sin(dLon/2) ** 2;
  return Math.round(R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)) * 1.25);
};

const getDistanciaAuto = (from, to) => {
  const f = from.toLowerCase().trim();
  const t = to.toLowerCase().trim();
  if (DISTANCIAS[`${f}-${t}`]) return DISTANCIAS[`${f}-${t}`];
  const c1 = CIUDADES_COORDS[f];
  const c2 = CIUDADES_COORDS[t];
  if (c1 && c2) return haversineKm(c1, c2);
  return null;
};

const getContribucionMinima = (km, pesoTramo) => {
  if (km <= 50)  return pesoTramo === 'pequeno' ? 3  : pesoTramo === 'medio' ? 5  : 8;
  if (km <= 150) return pesoTramo === 'pequeno' ? 5  : pesoTramo === 'medio' ? 8  : 12;
  if (km <= 300) return pesoTramo === 'pequeno' ? 7  : pesoTramo === 'medio' ? 11 : 16;
  if (km <= 500) return pesoTramo === 'pequeno' ? 10 : pesoTramo === 'medio' ? 15 : 22;
  return pesoTramo === 'pequeno' ? 13 : pesoTramo === 'medio' ? 19 : 28;
};

// Dominios de email aceptados (coincide con el registro: solo proveedores comunes)
const DOMINIOS_EMAIL_VALIDOS = [
  'gmail.com', 'hotmail.com', 'hotmail.es', 'outlook.com', 'outlook.es',
  'yahoo.com', 'yahoo.es', 'icloud.com', 'me.com', 'live.com',
  'protonmail.com', 'proton.me', 'sendvigo.com',
];

// Valida un campo suelto y devuelve un mensaje de error o '' si es válido
const validarCampo = (nombre, valor) => {
  switch (nombre) {
    case 'from':
    case 'to': {
      if (!valor || valor.trim().length < 3) return 'Mínimo 3 caracteres';
      if (/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/.test(valor)) return 'Solo letras y espacios';
      return '';
    }
    case 'price': {
      const num = parseFloat(valor);
      if (!valor || isNaN(num)) return 'Número no válido';
      if (num < 3) return 'Mínimo 3€';
      if (num > 10000) return 'Máximo 10.000€';
      return '';
    }
    case 'receiverEmail': {
      if (!valor) return '';
      const dominio = valor.split('@')[1]?.toLowerCase();
      if (!valor.includes('@') || !dominio || !DOMINIOS_EMAIL_VALIDOS.includes(dominio)) {
        return 'Email no válido (Gmail, Hotmail, Outlook...)';
      }
      return '';
    }
    case 'receiverName': {
      if (!valor) return '';
      if (valor.trim().length < 2) return 'Mínimo 2 caracteres';
      if (/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/.test(valor)) return 'Solo letras y espacios';
      return '';
    }
    case 'receiverPhone': {
      if (!valor) return '';
      if (!/^\+?[0-9\s]{9,15}$/.test(valor)) return 'Formato: +34 600 000 000';
      return '';
    }
    case 'description': {
      if (!valor || valor.trim().length < 3) return 'Describe qué envías (mínimo 3 caracteres)';
      if (!/[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ]/.test(valor)) return 'Describe qué es con palabras, no solo números';
      return '';
    }
    default:
      return '';
  }
};

const InputField = ({ placeholder, value, onChange, onBlur, type = 'text', error }) => (
  <div>
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      style={{
        backgroundColor: '#111318',
        border: `1px solid ${error ? '#ef4444' : '#2a2d35'}`,
        color: 'white',
        borderRadius: '12px',
        padding: '12px 14px',
        fontSize: '14px',
        width: '100%',
      }}
      className="focus:outline-none focus:ring-1 focus:ring-orange-500 placeholder-gray-600"
    />
    {error && (
      <p style={{ color: '#ef4444', fontSize: '11px', marginTop: '4px' }}>{error}</p>
    )}
  </div>
);

const Section = ({ title, children }) => (
  <div className="mb-6">
    <p style={{color: '#f97316', fontSize: '12px', fontWeight: '600',
      textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '12px'}}>
      {title}
    </p>
    {children}
  </div>
);

export default function NewPackage({ onBack, onTabChange, onOpenPackage }) {
  const { token } = useAuth();
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [pesoTramo, setPesoTramo] = useState('pequeno');
  const [receiverEmail, setReceiverEmail] = useState('');
  const [noEmail, setNoEmail] = useState(false);
  const [receiverPhone, setReceiverPhone] = useState('');
  const [price, setPrice] = useState('');
  const [description, setDescription] = useState('');
  const [mensajePersonal, setMensajePersonal] = useState('');
  const [kmManuales, setKmManuales] = useState('');
  const [pickupDisponibilidad, setPickupDisponibilidad] = useState('ahora');
  const [pickupTime, setPickupTime] = useState('');
  const [pickupDate, setPickupDate] = useState('');
  const [showReceiverInfo, setShowReceiverInfo] = useState(false);
  const [showOrigenInfo, setShowOrigenInfo] = useState(false);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const [receiverName, setReceiverName] = useState('');
  const [errores, setErrores] = useState({});

  const kmAuto = from && to ? getDistanciaAuto(from, to) : null;
  const rutaReconocida = kmAuto !== null;
  const kmFinales = kmAuto ?? (kmManuales ? parseInt(kmManuales) : null);
  const contribucionMinima = kmFinales ? getContribucionMinima(kmFinales, pesoTramo) : null;
  const pesoKg = pesoTramo === 'pequeno' ? 1 : pesoTramo === 'medio' ? 5 : 15;

  // Valida un campo al perder el foco (onBlur) y guarda el error en el estado
  const handleBlur = (nombre, valor) => {
    const error = validarCampo(nombre, valor);
    setErrores(prev => ({ ...prev, [nombre]: error }));
  };

  const handleSubmit = async () => {
    // Revalida todos los campos relevantes antes de publicar
    const camposAValidar = {
      from,
      to,
      price,
      description,
      receiverEmail: noEmail ? '' : receiverEmail,
      receiverName: noEmail ? receiverName : '',
      receiverPhone: noEmail ? receiverPhone : '',
    };

    const nuevosErrores = {};
    Object.entries(camposAValidar).forEach(([nombre, valor]) => {
      nuevosErrores[nombre] = validarCampo(nombre, valor);
    });
    setErrores(nuevosErrores);

    const hayErrores = Object.values(nuevosErrores).some(e => e);
    if (hayErrores) {
      setMessage('Por favor corrige los errores marcados en rojo antes de publicar');
      return;
    }

    if (from.trim().toLowerCase() === to.trim().toLowerCase()) {
      setMessage('El origen y el destino no pueden ser la misma ciudad');
      return;
    }
    if (!kmFinales) {
      setMessage('Añade los km aproximados de la ruta');
      return;
    }
    if (contribucionMinima && parseFloat(price) < contribucionMinima) {
      setMessage('La contribución es muy baja para esta ruta — auméntala un poco');
      return;
    }
    if (!noEmail && !receiverEmail) {
      setMessage('Indica el email de quien recibe');
      return;
    }
    if (noEmail && (!receiverName || !receiverPhone)) {
      setMessage('Indica nombre y teléfono de quien recibe si no tiene email');
      return;
    }

    try {
      await createPackage({
        from, to, weight: pesoKg,
        receiverEmail: noEmail ? null : receiverEmail.toLowerCase().trim(),
        price: parseFloat(price),
        description,
        mensajePersonal,
        receiverPhone: receiverPhone || null,
        receiverName: receiverName || null,
      }, token);
      setSuccess(true);
      setMessage('');
    } catch (error) {
      setMessage('Error: ' + error.message);
    }
  };

  if (success) return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
      style={{backgroundColor: '#111318'}}>
      <div className="text-5xl mb-4">🙌</div>
      <h2 className="text-white font-semibold text-xl mb-2">¡Pedido publicado!</h2>
      <p className="text-gray-500 text-sm mb-1">Tu mensaje ya es visible para quienes viajan por esa ruta</p>
      <p style={{color: '#f97316', fontSize: '12px'}} className="mb-8">Cada viaje, una oportunidad de ayudar</p>
      <button onClick={onBack} style={{backgroundColor: '#f97316'}}
        className="text-white font-semibold px-6 py-3 rounded-2xl text-sm">
        Volver al inicio
      </button>
    </div>
  );

  return (
    <div className="min-h-screen pb-24" style={{backgroundColor: '#111318'}}>
      <Navbar onBack={onBack} onOpenPackage={onOpenPackage} />

      <div className="max-w-lg mx-auto px-4 pt-6" style={{overflow: 'hidden'}}>
        <div className="mb-6">
          <p className="text-gray-500 text-sm mb-0.5">Nueva solicitud</p>
          <h1 className="text-white font-semibold text-2xl">Pedir ayuda con un envío</h1>
          <p style={{color: '#f97316', fontSize: '12px'}} className="mt-1">Cada viaje, una oportunidad de ayudar 🤝</p>
        </div>

        <div className="rounded-2xl p-5" style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35', overflow: 'hidden', minWidth: 0}}>
          {/* Ruta */}
          <Section title="📍 Ruta">
            <div className="flex items-center gap-2 mb-2">
              <button onClick={() => setShowOrigenInfo(!showOrigenInfo)}>
                <FaQuestionCircle style={{color: '#4b5563', fontSize: '12px'}} />
              </button>
              {showOrigenInfo && (
                <p className="text-gray-500 text-xs">Escribe el nombre de la ciudad — Madrid, Granada, Sevilla...</p>
              )}
            </div>
            <div className="flex flex-col gap-2">
              <InputField
                placeholder="¿Desde dónde? — Granada, Madrid..."
                value={from}
                onChange={e => setFrom(e.target.value)}
                onBlur={e => handleBlur('from', e.target.value)}
                error={errores.from}
              />
              <InputField
                placeholder="¿Hasta dónde? — Sevilla, Barcelona..."
                value={to}
                onChange={e => setTo(e.target.value)}
                onBlur={e => handleBlur('to', e.target.value)}
                error={errores.to}
              />
            </div>
            {from && to && (
              rutaReconocida ? (
                <div className="mt-2 flex items-center gap-1.5">
                  <span style={{color: '#22c55e', fontSize: '11px'}}>✓</span>
                  <p style={{color: '#6b7280', fontSize: '11px'}}>Distancia estimada: {kmFinales} km</p>
                </div>
              ) : (
                <div className="mt-3">
                  <p style={{color: '#6b7280', fontSize: '12px'}} className="mb-2">
                    📍 Ruta nueva — ¿sabes aproximadamente cuántos km son?
                  </p>
                  <InputField
                    placeholder="Km aproximados (opcional)"
                    value={kmManuales}
                    onChange={e => setKmManuales(e.target.value)}
                  />
                  {kmManuales && (
                    <div className="mt-1.5 flex items-center gap-1.5">
                      <span style={{color: '#22c55e', fontSize: '11px'}}>✓</span>
                      <p style={{color: '#6b7280', fontSize: '11px'}}>{kmManuales} km — gracias, nos ayuda a mejorar</p>
                    </div>
                  )}
                </div>
              )
            )}
          </Section>

          {/* Tu mensaje */}
          <Section title="💬 Tu mensaje">
            <p style={{color: '#6b7280', fontSize: '12px'}} className="mb-2">
              Un mensaje cercano genera más confianza — cuéntale algo a quien viaja
            </p>
            <textarea
              placeholder={"Ej: Buenas! Si alguien viaja hacia Barcelona y aún tiene hueco en el coche, estaría encantado de que me llevara un paquete pequeño y ayudo con los gastos del viaje 🙌"}
              value={mensajePersonal}
              onChange={e => setMensajePersonal(e.target.value)}
              rows={4}
              maxLength={300}
              style={{backgroundColor: '#111318', border: '1px solid #2a2d35', color: 'white',
                borderRadius: '12px', padding: '12px 14px', fontSize: '13px', width: '100%',
                maxWidth: '100%', resize: 'none', lineHeight: '1.5',
                boxSizing: 'border-box', wordBreak: 'break-word', overflowWrap: 'break-word'}}
              className="focus:outline-none focus:ring-1 focus:ring-orange-500 placeholder-gray-600"
            />
            <p style={{
              color: mensajePersonal.length > 270 ? '#f97316' : '#3a3d45',
              fontSize: '10px'
            }} className="mt-1 text-right">
              {mensajePersonal.length}/300
            </p>
          </Section>

          {/* Paquete */}
          <Section title="📦 Qué necesitas enviar">
            <InputField
              placeholder="Ej: llaves de casa, documentos, ropa..."
              value={description}
              onChange={e => setDescription(e.target.value)}
              onBlur={e => handleBlur('description', e.target.value)}
              error={errores.description}
            />
            <p style={{color: '#6b7280', fontSize: '12px'}} className="mt-3 mb-2">Tamaño aproximado</p>
            <div className="grid grid-cols-3 gap-2">
              {[
                { key: 'pequeno', label: '🔑 Pequeño', sub: '< 3kg' },
                { key: 'medio',   label: '👜 Mediano',  sub: '3-10kg' },
                { key: 'grande',  label: '🧳 Grande',   sub: '> 10kg' },
              ].map(opt => (
                <button key={opt.key} onClick={() => setPesoTramo(opt.key)}
                  style={pesoTramo === opt.key
                    ? {backgroundColor: '#f9731615', border: '1px solid #f97316', borderRadius: '12px', padding: '10px 6px'}
                    : {backgroundColor: '#111318', border: '1px solid #2a2d35', borderRadius: '12px', padding: '10px 6px'}
                  }
                  className="text-center transition duration-150">
                  <p style={{fontSize: '12px', fontWeight: '600', color: pesoTramo === opt.key ? '#f97316' : '#9ca3af'}}>{opt.label}</p>
                  <p style={{fontSize: '10px', color: '#6b7280', marginTop: '2px'}}>{opt.sub}</p>
                </button>
              ))}
            </div>
          </Section>

          {/* Disponibilidad */}
          <Section title="🕐 ¿Cuándo está listo?">
            <div className="flex flex-col gap-2">
              {[
                { key: 'ahora', label: '✅ Listo ahora mismo' },
                { key: 'hoy',   label: '🕐 Hoy a partir de una hora' },
                { key: 'otro',  label: '📅 Otro día' },
              ].map(opt => (
                <button key={opt.key} onClick={() => setPickupDisponibilidad(opt.key)}
                  style={pickupDisponibilidad === opt.key
                    ? {backgroundColor: '#f9731615', border: '1px solid #f97316', borderRadius: '12px', padding: '10px 14px', textAlign: 'left'}
                    : {backgroundColor: '#111318', border: '1px solid #2a2d35', borderRadius: '12px', padding: '10px 14px', textAlign: 'left'}
                  }>
                  <span style={{fontSize: '13px', color: pickupDisponibilidad === opt.key ? '#f97316' : '#9ca3af',
                    fontWeight: pickupDisponibilidad === opt.key ? '600' : '400'}}>
                    {opt.label}
                  </span>
                </button>
              ))}
            </div>
            {pickupDisponibilidad === 'hoy' && (
              <div className="mt-2">
                <InputField type="time" placeholder="" value={pickupTime} onChange={e => setPickupTime(e.target.value)} />
              </div>
            )}
            {pickupDisponibilidad === 'otro' && (
              <div className="mt-2 flex flex-col gap-2">
                <InputField type="date" placeholder="" value={pickupDate} onChange={e => setPickupDate(e.target.value)} />
                <InputField type="time" placeholder="" value={pickupTime} onChange={e => setPickupTime(e.target.value)} />
              </div>
            )}
          </Section>

          {/* Contribución */}
          <Section title="🤝 Compartir gastos del viaje">
            {kmFinales && (
              <div className="mb-3 px-3 py-2 rounded-xl flex items-center gap-2"
                style={{backgroundColor: '#f9731610', border: '1px solid #f9731625'}}>
                <span style={{fontSize: '13px'}}>📊</span>
                <p style={{color: '#9ca3af', fontSize: '11px'}}>
                  En esta ruta la gente suele contribuir entre{' '}
                  <span style={{color: '#f97316', fontWeight: '600'}}>{Math.round(contribucionMinima * 1.4)}€</span>
                  {' '}y{' '}
                  <span style={{color: '#f97316', fontWeight: '600'}}>{Math.round(contribucionMinima * 2)}€</span>
                </p>
              </div>
            )}

            <InputField
              placeholder="¿Con cuánto quieres contribuir al viaje?"
              value={price}
              onChange={e => setPrice(e.target.value)}
              onBlur={e => handleBlur('price', e.target.value)}
              error={errores.price}
            />

            {price && kmFinales && !errores.price && (() => {
              const p = parseFloat(price);
              const min = contribucionMinima;
              const bueno = min * 1.4;
              const genial = min * 1.8;

              if (p < min) return (
                <div className="mt-2 px-3 py-2 rounded-xl flex items-center gap-2"
                  style={{backgroundColor: '#ff000010', border: '1px solid #ff000025'}}>
                  <span style={{fontSize: '14px'}}>⚠️</span>
                  <div>
                    <p style={{color: '#f87171', fontSize: '12px', fontWeight: '600'}}>Contribución muy baja</p>
                    <p style={{color: '#6b7280', fontSize: '11px'}}>Puede que nadie se ofrezca a ayudarte con esta aportación</p>
                  </div>
                </div>
              );
              if (p < bueno) return (
                <div className="mt-2 px-3 py-2 rounded-xl flex items-center gap-2"
                  style={{backgroundColor: '#f59e0b10', border: '1px solid #f59e0b25'}}>
                  <span style={{fontSize: '14px'}}>🟡</span>
                  <div>
                    <p style={{color: '#f59e0b', fontSize: '12px', fontWeight: '600'}}>Posibilidades medias</p>
                    <p style={{color: '#6b7280', fontSize: '11px'}}>Con {Math.round(bueno)}€ tendrías más opciones</p>
                  </div>
                </div>
              );
              if (p < genial) return (
                <div className="mt-2 px-3 py-2 rounded-xl flex items-center gap-2"
                  style={{backgroundColor: '#22c55e10', border: '1px solid #22c55e25'}}>
                  <span style={{fontSize: '14px'}}>✅</span>
                  <div>
                    <p style={{color: '#22c55e', fontSize: '12px', fontWeight: '600'}}>Buena contribución</p>
                    <p style={{color: '#6b7280', fontSize: '11px'}}>Seguro que alguien se ofrece a ayudarte</p>
                  </div>
                </div>
              );
              return (
                <div className="mt-2 px-3 py-2 rounded-xl flex items-center gap-2"
                  style={{backgroundColor: '#6366f110', border: '1px solid #6366f125'}}>
                  <span style={{fontSize: '14px'}}>🚀</span>
                  <div>
                    <p style={{color: '#818cf8', fontSize: '12px', fontWeight: '600'}}>¡Muy generoso!</p>
                    <p style={{color: '#6b7280', fontSize: '11px'}}>Con esta aportación tendrás respuestas rápido 🙌</p>
                  </div>
                </div>
              );
            })()}
          </Section>

          {/* Receptor */}
          <Section title="👤 ¿Quién recibe el paquete?">
            <div className="flex items-center gap-2 mb-2">
              <button onClick={() => setShowReceiverInfo(!showReceiverInfo)}>
                <FaQuestionCircle style={{color: '#4b5563', fontSize: '12px'}} />
              </button>
              {showReceiverInfo && (
                <p className="text-gray-500 text-xs">Quien viaja podrá contactarle si surge algún imprevisto</p>
              )}
            </div>
            {!noEmail && (
              <InputField
                placeholder="Email de quien recibe"
                value={receiverEmail}
                onChange={e => setReceiverEmail(e.target.value)}
                onBlur={e => handleBlur('receiverEmail', e.target.value)}
                error={errores.receiverEmail}
              />
            )}
            <div className="flex items-center gap-2 mt-3">
              <input type="checkbox" id="noEmail" checked={noEmail} onChange={e => setNoEmail(e.target.checked)}
                className="accent-orange-500 w-4 h-4" />
              <label htmlFor="noEmail" style={{color: '#6b7280', fontSize: '13px'}}>No tiene email</label>
            </div>
            {noEmail && (
              <div className="mt-2 flex flex-col gap-2">
                <InputField
                  placeholder="Nombre de quien recibe"
                  value={receiverName}
                  onChange={e => setReceiverName(e.target.value)}
                  onBlur={e => handleBlur('receiverName', e.target.value)}
                  error={errores.receiverName}
                />
                <InputField
                  placeholder="Teléfono de quien recibe"
                  value={receiverPhone}
                  onChange={e => setReceiverPhone(e.target.value)}
                  onBlur={e => handleBlur('receiverPhone', e.target.value)}
                  error={errores.receiverPhone}
                />
              </div>
            )}
          </Section>

          {message && (
            <div className="mb-4 px-4 py-2 rounded-xl text-sm"
              style={message.includes('publicado')
                ? {backgroundColor: '#22c55e15', border: '1px solid #22c55e30', color: '#4ade80'}
                : {backgroundColor: '#ff000015', border: '1px solid #ff000030', color: '#f87171'}
              }>
              {message}
            </div>
          )}

          <button onClick={handleSubmit}
            style={{backgroundColor: '#f97316', width: '100%', color: 'white',
              fontWeight: '600', padding: '14px', borderRadius: '14px', fontSize: '14px'}}>
            Publicar mi solicitud
          </button>
          <p style={{color: '#3a3d45', fontSize: '11px'}} className="text-center mt-3">
            Quienes viajan por esa ruta verán tu mensaje 🤝
          </p>
        </div>
      </div>

      <BottomNav active="home" onChange={onTabChange} unreadCount={0} />
    </div>
  );
}
